import { render, staticRenderFns } from "./BlockDeliveryAddresses.vue?vue&type=template&id=d3d408ee&"
import script from "./BlockDeliveryAddresses.vue?vue&type=script&lang=js&"
export * from "./BlockDeliveryAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports